// assets.js - 所有资源加载
export function loadAllAssets() {
    // 这些函数现在可用，因为 kaplay() 已初始化
    loadSprite('menu', 'https://cdn.zhouheng.icu/pela_vocab/images/menu.png');
    loadSprite('mark', 'https://cdn.zhouheng.icu/pela_vocab/images/mark.png');
    loadSprite('controller', 'https://cdn.zhouheng.icu/pela_vocab/images/controller.png');
    loadSprite('marks_legend', 'https://cdn.zhouheng.icu/pela_vocab/images/marks_legend.png');
    loadSprite('paper', 'https://cdn.zhouheng.icu/pela_vocab/images/paper.png');
    loadSprite('star', 'https://cdn.zhouheng.icu/pela_vocab/images/star.png');
    loadSprite('rank', 'https://cdn.zhouheng.icu/pela_vocab/images/rank.png');
    loadSprite('question_mark', 'https://cdn.zhouheng.icu/pela_vocab/images/question_mark.png');
    loadSprite('flashcards', 'https://cdn.zhouheng.icu/pela_vocab/images/flashcards.png');
    loadSprite('reback_mark', 'https://cdn.zhouheng.icu/pela_vocab/images/reback_mark.png');
    loadSprite('config', 'https://cdn.zhouheng.icu/pela_vocab/images/config.png');
    loadSprite('classes', 'https://cdn.zhouheng.icu/pela_vocab/images/classes.png');
    loadSprite('tower', 'https://cdn.zhouheng.icu/pela_vocab/images/tower1.png');
    loadSprite('world', 'https://cdn.zhouheng.icu/pela_vocab/images/world.png');
    loadSprite('skuller-o', 'https://cdn.zhouheng.icu/pela_vocab/images/skuller-o.png');
    loadSprite('login_bg', 'https://cdn.zhouheng.icu/pela_vocab/images/pela_story.png');
    

    loadSound('game_theme', 'https://cdn.zhouheng.icu/pela_vocab/sounds/Woodland%20Fantasy.mp3');
    loadSound('town_theme', 'https://cdn.zhouheng.icu/pela_vocab/sounds/TownTheme.mp3');
    loadSound('enemy_explosion', 'https://cdn.zhouheng.icu/pela_vocab/sounds/enemy_explosion.mp3');
    loadFont('base_font', 'https://cdn.zhouheng.icu/pela_vocab/font/DaMengKaTongTi-Regular-2.ttf');

    // 如果有自定义 loadHappy，在此调用
    if (typeof loadHappy === 'function') {
        loadHappy();
    }

    // 加载 SpriteSheet 
    loadSprite('slime', 'https://cdn.zhouheng.icu/pela_vocab/images/slime.png', {
        sliceX: 7,
        sliceY: 5,
        anims: {
            idle: { from: 0, to: 3, speed: 5, loop: true },
            run:  { from: 7, to: 12, speed: 8, loop: true },
            jump: { from: 14, to: 20, speed: 10, loop: true },
            death: { from: 28, to: 32, speed: 10, loop: false },
        },
    });

    // 加载 SpriteSheet 
    loadSprite('spider', 'https://cdn.zhouheng.icu/pela_vocab/images/spider.png', {
        sliceX: 9,
        sliceY: 16,
        anims: {
            idle: { from: 0, to: 4, speed: 5, loop: true },
            run:  { from: 81, to: 86, speed: 6, loop: true },
            jump: { from: 90, to: 98, speed: 9, loop: true },
            death: { from: 65, to: 63, speed: 10, loop: false },
        },
    });

    // 加载 SpriteSheet
    loadSprite('player', 'https://cdn.zhouheng.icu/pela_vocab/images/player.png', {
        sliceX: 6,
        sliceY: 10,
        anims: {
            idle: { from: 0, to: 5, speed: 6, loop: true },
            side_idle:  { from: 6, to: 11, speed: 6, loop: true },
            back_idle: { from: 12, to: 17, speed: 6, loop: true },
            front_walk:  { from: 18, to: 23, speed: 6, loop: true },
            side_walk:  { from: 24, to: 29, speed: 6, loop: true },
            back_walk: { from: 30, to: 35, speed: 6, loop: true },
        },
    });

}